// Common column presets for AppGrids components
// These provide reusable patterns while maintaining flexibility

import moment from 'moment';
import { UserNameCell } from './cellComponents';

export const commonColumns = {
  // Date and Time columns (most common)
  date: (width = '7%', key = 'createdAt', dataKey = null) => ({
    key,
    header: 'Date',
    width,
    render: dataKey ? 
      (value, row) => row[dataKey] ? moment(row[dataKey]).format('DD.MM.YYYY') : '---' :
      { type: 'date' }
  }),
  
  time: (width = '4%', key = 'createdAt', dataKey = null) => ({
    key,
    header: 'Time',
    width,
    render: dataKey ? 
      (value, row) => row[dataKey] ? moment(row[dataKey]).format('HH:mm') : '---' :
      { type: 'time' }
  }),
  
  // User/Author columns with truncation and tooltip
  user: (width = '15%', key = 'author', maxLength = 18) => ({
    key,
    header: 'User',
    width,
    render: { component: UserNameCell, props: { maxLength } }
  }),
  
  // User columns by specific property path
  userByPath: (width = '15%', path = 'fullName', maxLength = 18) => ({
    key: path,
    header: 'User',
    width,
    render: { component: UserNameCell, props: { maxLength } }
  }),
  
  // Location columns
  city: (width = '12%', key = 'property') => ({
    key,
    header: 'City',
    width,
    render: (value, row) => row[key]?.cityEN || '---'
  }),
  
  propertyLocation: (width = '12%') => ({
    key: 'propertyLocation',
    header: 'Property Located In',
    width,
    render: () => '---' // Not available in most APIs
  }),
  
  // Common data types
  number: (key, header, width = '12%') => ({
    key,
    header,
    width,
    render: { type: 'number' }
  }),
  
  count: (key, header, width = '10%') => ({
    key,
    header,
    width,
    render: { type: 'count' }
  }),
  
  boolean: (key, header, width = '10%') => ({
    key,
    header,
    width,
    render: { type: 'boolean' }
  }),
  
  currency: (key, header, width = '12%') => ({
    key,
    header,
    width,
    render: { type: 'currency' }
  }),
  
  fileSize: (key, header, width = '12%') => ({
    key,
    header,
    width,
    render: { type: 'fileSize' }
  })
}; 